/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import {
  STATUS_MSG,
  SUCCESS_MSG,
} from '../../../../SharedModules/Errors/constantMessageData';

//  dispatch Maintanance Price Header Details
export const dispatchManufacturerList = (data) => ({
  type: actionTypes.GET_MANUFACTURER_LIST,
  payload: data,
});

export const setSelectedDrugInStore = (data) => ({
  type: actionTypes.SET_SELECTED_DRUG,
  payload: data,
});

//  dispatch All Drug Families
export const dispatchAllDrugFamilies = (data) => ({
  type: actionTypes.GET_DRUG_FAMILIES,
  payload: data,
});

//  dispatch Maintanance Price Header Details
export const dispatchMaintanancePriceDetails = (data) => ({
  type: actionTypes.GET_HEADER_PRICE_DETAILS,
  payload: data,
});

//  dispatch Maintanance Price Grid Details
export const dispatchMaintanancePriceGridDetails = (data) => ({
  type: actionTypes.GET_PRICE_GRID_DETAILS,
  payload: data,
});

// get Manufaxcturer List
export const getManufactirerList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_MFG_GRID_DATA, value)
    .then((response) => {
      return dispatch(dispatchManufacturerList(response.data));
    })
    .catch((response) => {
      dispatch(dispatchManufacturerList([]));
    });
};

// get All Drug Families
export const getAllDrugFamilies = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_DRUG_FAMILIES_USING_MFGID, value)
    .then((response) => {
      return dispatch(dispatchAllDrugFamilies(response.data));
    })
    .catch((response) => {
      dispatch(dispatchAllDrugFamilies([]));
    });
};
export const storeUpdatedDetailsPage = (val) => {
  return {
    type: actionTypes.STORE_UPDATED_PAGE,
    payload: val,
  };
};

export const onChangePage = (val) => {
  return {
    type: actionTypes.UPDATED_PAGE,
    payload: val,
  };
};
// get Maintanance Price Header Details
export const getMaintanancePriceHeaderDetails = async (values) => {
  try {
    const response = await axios.post(
      serviceEndPoint.GET_HEADER_DETAILS,
      values
    );
    if (response.data) {
      return response.data;
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
};

// get Maintanance Price Grid Details
export const getMaintanancePriceGridDetails = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_GRID_PRICE_DETAILS, value)
    .then((response) => {
      return dispatch(dispatchMaintanancePriceGridDetails(response.data));
    })
    .catch((response) => {
      dispatch(dispatchMaintanancePriceGridDetails([]));
    });
};

export const dispatchPageCountwithDetails = (data) => ({
  type: actionTypes.GET_PAGE_COUNT,
  payload: data,
});

export const getNdcDetailsCall = async (values) => {
  try {
    const response = await axios.post(serviceEndPoint.NDC_DETAILS, values);
    if (response.data && response.data.data && response.data.data.length > 0) {
      return response.data;
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
};

// get Maintanance Price Grid Details
export const getPlanTypeDescription = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_REFERENCE_DATA, value)
    .then((response) => {
      return dispatch(dispatchPlanTypeDescription(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanTypeDescription([]));
    });
};

export const dispatchPlanTypeDescription = (data) => ({
  type: actionTypes.GET_PLANTYPE_DESCRIPTION,
  payload: data,
});

// get Maintanance Price Grid Details

export const saveMaintainPriceDetails = async (values) => {
  try {
    const response = await axios.post(
      serviceEndPoint.SAVE_PRICE_DETAILS,
      values
    );
    if (response.data) {
      return response.data;
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
};

export const dispatchSavePricedetails = (data) => ({
  type: actionTypes.SAVE_PRICE_DETAILS,
  payload: data,
});

export const showAllQuarters = (val) => {
  return {
    type: actionTypes.SHOW_ALL_QUARTERS,
    payload: val,
  };
};

export const deletedUpdatedRow = (val) => {
  return {
    type: actionTypes.DELETED_UPDATED_ROW,
    payload: val,
  };
};

export const storeBlurState = (val) => {
  return {
    type: actionTypes.STORE_BLUR_STATE,
    payload: val,
  };
};

export const storeOverlapState = (val = [{ startQtrOverlap: false }]) => {
  return {
    type: actionTypes.STORE_OVERLAP_STATE_ERR,
    payload: val,
  };
};

export const storePriceDetailsErrors = (val) => {
  return {
    type: actionTypes.PRICE_DETAIL_ERRORS,
    payload: val,
  };
};

export const storeRebatePriceDetails = (val) => {
  return {
    type: actionTypes.STORE_REBATE_PRICE_DETAILS,
    payload: val,
  };
};

export const storePriceLevelErrors = (val) => {
  return {
    type: actionTypes.PRICE_DETAILS_ERRORS,
    payload: val,
  };
};

export const storePriceSearchInputData = (val) => {
  return {
    type: actionTypes.REBET_PRICE_LEVEL_SEARCH_INPUT_DATA,
    payload: val,
  };
};
// REBATE PROGRAM

// REBATE PROGRAM

export const getRebatePrograms = (val) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: val })
    .then((response) => {
      let { data, status, message } = response.data;
      let list = [];
      if (status === STATUS_MSG && message === SUCCESS_MSG) {
        if (Array.isArray(data) && data.length > 0) {
          list = data.map((val) => ({
            ...val,
            id: val.rebateProgramCd,
            name: `${val.rebateProgramCd} | ${val.shortDescr}`,
          }));
          list = list.sort((key, val) =>
            key.name.toLowerCase().localeCompare(val.name.toLowerCase())
          );
        }
      }
      return list;
    })
    .catch(() => {
      return [];
    });
};

export const storeUpdatedList = (data) => ({
  type: actionTypes.STORE_UPDATED_LIST,
  payload: data,
});

export const storeMfgId = (data) => ({
  type: actionTypes.MFG_ID,
  payload: data,
});

export const errorControl = (data) => ({
  type: actionTypes.ERROR_CONTROL,
  payload: data,
});

// Update Maintain Price Details
export const updateMaintainPriceDetails = async (values) => {
  try {
    const response = await axios.post(
      serviceEndPoint.UPDATE_PRICE_DETAILS,
      values
    );
    if (response.data) {
      return response.data;
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
};

//  dispatch Maintanance Price Header Details
export const dispatchUpdateMaintainPriceDetails = (data) => ({
  type: actionTypes.UPDATE_MAINTAIN_PRICE_DETAILS,
  payload: data,
});

export const storeAllListed = (data) => ({
  type: actionTypes.STORE_ALL_LIST,
  payload: data,
});

export const onchangePayloadData = (data) => ({
  type: actionTypes.ONCHANGE_PAYLOAD,
  payload: data,
});

export const clearReduxforRebatePriceSearch = () => (dispatch) => {
  // dispatch(dispatchPlanTypeDescription({}));
  // dispatch(dispatchAllDrugFamilies({}));
  // dispatch(dispatchManufacturerList(false));
  // dispatch(storePriceSearchInputData({}));
  // dispatch(storeMfgId(null));
  // dispatch(errorControl({}));
  return { type: actionTypes.CLEAR_SEARCH_REDUX };
};

export const clearReduxforRebatePriceDetails = () => (dispatch) => {
 // dispatch(dispatchPageCountwithDetails({}));
  dispatch(dispatchPlanTypeDescription({}));
  dispatch(dispatchManufacturerList(false));
  dispatch(storeMfgId(null));
  dispatch(errorControl({}));
  dispatch(storeAllListed({}));
  dispatch(onchangePayloadData({}));
  dispatch(deletedUpdatedRow({}));
};
